// extracted by mini-css-extract-plugin
export default {"wrap":"m70zlZmIbutJBCP570fy","main":"gg6RBlVE0XZMqpxrohl1","group":"Cy5NBa0hB9whXKteoGsy","list":"I7V4v5kAPofE3iNB6y4Z"};